import type { KioskConfig } from '../types/kioskConfig';
import KioskConnectionMode from '../types/KioskConnectionMode';

const kioskConfig: KioskConfig = {
  KioskCompanyName: '[9B3]Ambulance Victoria',
  KioskCompanyNameRaw: 'Ambulance Victoria',
  KioskName: 'Kiosk Name',
  KioskCompanyTimezone: 'Australia/Sydney',
  KioskId: 5,
  KioskConnectionMode: KioskConnectionMode.Cookie,
  KioskCompanyId: 1,
  KioskAppConfigs: {
    KIOSK_VERSION: 'V1.0.1',
    PRODUCT_VERSION: '3.0.7',
    WEEK_START: '1',
    TIMESHEET_CLOSEST_BLOCK: '15',
    SHIFT_TEMPLATE_SLOTS_CONFIG: [
      {
        SlotLabel: 'Meal Break (unpaid)',
        SlotName: 'Lunch Break',
        SlotValue: 'M',
      },
      {
        SlotLabel: 'Rest Break (paid)',
        SlotName: 'Short Break',
        SlotValue: 'R',
      },
    ],
    SHORT_TIME_FORMAT: 'h:i A',
    REQUIRE_KIOSK_PHOTO_BUMP_SHIFT: '1',
    CAN_SUBMIT_SHIFT_VIA_DESK: '1',
    HAS_CLOCKIN_CUSTOM_FIELDS: false,
    ALLOW_KIOSK_PHOTO_CLOCKIN: '1',
    ENABLE_MULTI_LOCATIONS: false,
    AUTHENTICATE_MODE: 0,
  },
  KioskBusinessSettings: {
    EMPLOYEE_LABEL: 'Team member',
    EMPLOYEE_LABEL_PLURAL: 'Team members',
    IS_EMPLOYEE_SENTIMENT_ENABLED: false,
    SHIFT_LABEL: 'Shift',
    SHIFT_LABEL_PLURAL: 'Shifts',
  },
};

export function getKioskConfigMock() {
  return kioskConfig;
}

export function getKioskConfigUnsortedBreakSlotsMock(): KioskConfig {
  return {
    ...kioskConfig,
    KioskAppConfigs: {
      ...kioskConfig.KioskAppConfigs,
      ['SHIFT_TEMPLATE_SLOTS_CONFIG']: [
        {
          SlotLabel: 'Rest Break (paid)',
          SlotName: 'Short Break',
          SlotValue: 'R',
        },
        {
          SlotLabel: 'Meal Break (unpaid)',
          SlotName: 'Lunch Break',
          SlotValue: 'M',
        },
      ],
    },
  };
}
